<template>
    <PortalProgress
        v-if="isPortal"
        :fillWidth
    />
    <AffiliateProgress
        v-else
        :fillWidth
    />
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'

import AffiliateProgress from './AffiliateProgress.vue'
import PortalProgress from './PortalProgress.vue'

const { isPortal } = defineProps<{
    isPortal: boolean
}>()

const progress = ref(0)

const imageWidth = computed(() => (isPortal ? 229 : 276))
const fillWidth = computed(() => (imageWidth.value * progress.value) / 100)

const customEaseIn = (t: number) => {
    if (t <= 0.7) {
        const normalizedT = t / 0.7
        return normalizedT * normalizedT * normalizedT * 0.4
    } else {
        const normalizedT = (t - 0.7) / 0.3
        return 0.4 + (1 - Math.pow(1 - normalizedT, 5)) * 0.6
    }
}

onMounted(() => {
    {
        progress.value = 0
        const startTime = Date.now()
        const duration = 2000 // Duration in milliseconds (1.8 seconds)

        const animate = () => {
            const elapsed = Date.now() - startTime
            const linearProgress = Math.min(elapsed / duration, 1)

            const easedProgress = customEaseIn(linearProgress)
            progress.value = easedProgress * 100

            if (linearProgress < 1) {
                requestAnimationFrame(animate)
            }
        }

        requestAnimationFrame(animate)
    }
})
</script>
